import React from 'react';

import Course, { Props as CourseProps } from './Course';
import useCourseCompare from 'Redux/courseCompare';
import { Course as CourseType } from 'Redux/courseCompare/types';

export interface Props extends CourseProps {
    compareCourseData: CourseType;
}

const CourseContainer: React.FC<Props> = props => {
    const { compareCourseData, ...rest } = props;
    const { store, addCourse, removeCourse } = useCourseCompare();

    const compareChecked = store.courses.some(course => course.id === compareCourseData.id);

    return (
        <Course
            {...rest}
            defaultCompareChecked={compareChecked}
            disabledCompareChecked={!compareChecked && store.courses.length >= 5}
            addCourseToCompare={() => addCourse(compareCourseData)}
            removeCourseToCompare={() => removeCourse(compareCourseData)}
        />
    );
};

export default CourseContainer;
